/** @deprecated - this is moved to libs */
export const PRODUCT_ID = {
    AUTO: 'AUTO',
    BROM: 'BROM',
    REIS: 'REIS',
    FIET: 'FIET',
    WOON: 'WOON',
    MOTR: 'MOTR',
    RB: 'RB',
    DIER: 'DIER',
    CVAN: 'CVAN',
    ONGV: 'ONGV',
    AANS: 'AANS'
};
